
import { Card } from "@/components/ui/card";
import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface Package {
  id: string;
  title: string;
  price: number;
  recipes: any[]; // Changed from any[] to handle Json type from database
  description?: string;
  image_url?: string;
  created_at: string;
  updated_at: string;
  user_id: string;
  visibility: string;
}

export const PackagesCard = () => {
  const [packages, setPackages] = useState<Package[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPackages = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      const { data, error } = await supabase
        .from('packages')
        .select('*')
        .eq('user_id', user.id)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching packages:', error);
      } else {
        // Parse the recipes JSON to ensure it's an array
        const parsedData = (data || []).map(pkg => ({
          ...pkg,
          recipes: Array.isArray(pkg.recipes) ? pkg.recipes : []
        }));
        setPackages(parsedData);
      }
      setLoading(false);
    };

    fetchPackages();
  }, []);

  return (
    <Card>
      <div className="p-6">
        <h2 className="text-xl font-semibold mb-4">My Packages</h2>
        <div className="space-y-4">
          {loading ? (
            <p className="text-muted-foreground text-sm">Loading packages...</p>
          ) : packages.length > 0 ? (
            packages.map(pkg => (
              <div key={pkg.id} className="flex items-center justify-between border-b pb-2">
                <div>
                  <h3 className="font-medium">{pkg.title}</h3>
                  <p className="text-sm text-muted-foreground">
                    {pkg.recipes.length} recipes • ${pkg.price}
                  </p>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => navigate(`/packages/${pkg.id}`)}
                >
                  View
                </Button>
              </div>
            ))
          ) : (
            <p className="text-muted-foreground text-sm">No packages created yet</p>
          )}
        </div>
      </div>
    </Card>
  );
};
